var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content)?_c('div',{style:(_vm.getStyle()),attrs:{"id":"underline-wrapper"}},[_c('div',{staticClass:"underline",style:(_vm.getColor())})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }